<template>
    <UpdateMaterial></UpdateMaterial>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const UpdateMaterial = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/JobEntry/UpdateMaterial.vue"
    )
);

export default {
    name: "Project_HelpUpdateMaterial", //The name you are in should not equal the name of the component you are importing.
    components: { UpdateMaterial, AuthLayout },
};
</script>
